export default theme => ({
  imageContainer: {
    padding: 10,
    display: "inline-block",
  },
});
